import { render, staticRenderFns } from "./processed-summary.vue?vue&type=template&id=8fbed14a&scoped=true"
import script from "./processed-summary.vue?vue&type=script&lang=js"
export * from "./processed-summary.vue?vue&type=script&lang=js"
import style0 from "./processed-summary.vue?vue&type=style&index=0&id=8fbed14a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbed14a",
  null
  
)

export default component.exports